import writingLegendCrouching from '@images/writing-legend-crouching.png'
import mangoStanding from '@images/mango-standing.png'
import gizmoStanding from '@images/gizmo-standing.png'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'

interface Signature {
  Element: HTMLImageElement
}

interface ImageData {
  src: string
  alt: string
}

export class ErrorsImageUnexpected extends Component<Signature> {
  @service subscriptionType!: SubscriptionTypeService

  get currentSubscriptionType() {
    return this.subscriptionType.current ?? SubscriptionType.Reading
  }

  get imageData(): ImageData {
    return {
      [SubscriptionType.Reading]: {
        src: gizmoStanding,
        alt: 'gizmo',
      },
      [SubscriptionType.Maths]: {
        src: mangoStanding,
        alt: 'mango the monkey',
      },
      [SubscriptionType.Writing]: {
        src: writingLegendCrouching,
        alt: 'writing legend crouching',
      },
    }[this.currentSubscriptionType]
  }

  <template>
    <img
      data-test-image-unexpected
      class="mx-auto"
      src={{this.imageData.src}}
      alt={{this.imageData.alt}}
      ...attributes
    />
  </template>
}
